module.exports = __webpack_public_path__ + "static/media/YF17_0.d290a1da.jpg";